export const SET_MODAL = 'GIFTYA/SET_MODAL';
export const SET_MODAL_RESET = 'GIFTYA/SET_MODAL_RESET';
export const SET_NAVIGATION = 'GIFTYA/SET_NAVIGATION';
export const SET_FOOTER_OPEN = 'GIFTYA/SET_FOOTER_OPEN';
export const SET_SCROLL_TO_ELEMENT = 'GIFTYA/SET_SCROLL_TO_ELEMENT';
export const SET_SCROLL_TO_ELEMENT_RESET = 'GIFTYA/SET_SCROLL_TO_ELEMENT_RESET';

export const setFooterOpen = (data) => ({
    type: SET_FOOTER_OPEN,
    data
});
export const setNavigation = (data) => ({
    type: SET_NAVIGATION,
    data
});
export const setModal = (data) => ({
    type: SET_MODAL,
    data
});
export const setModalReset = (data) => ({
    type: SET_MODAL_RESET,
    data
});
export const setScrollToElement = (data) => ({
    type: SET_SCROLL_TO_ELEMENT,
    data
});
export const setScrollToElementReset = (data) => ({
    type: SET_SCROLL_TO_ELEMENT_RESET,
    data
});